<template>
  <div class="add-expert">
    <!-- <SignTitle title="基本信息" /> -->

    <van-field label-class="affixs-label" required>
      <template #label>
        <span
          class="custom-title"
          error-message-align="right"
          :error-message="validate.fieldMsg.head"
          >评委头像</span
        >
        <span class="custom-tit">(jpg/png格式最多一张，每张不超过1M)</span>
      </template>
    </van-field>
    <div class="expert-head">
      <!-- <van-uploader
        :before-delete="headBeforeDel"
        v-model="head"
        :max-count="1"
        :before-read="uploadBeforeRead"
      /> -->
      <van-uploader
        :before-delete="headBeforeDel"
        v-model="head"
        :max-count="1"
        :before-read="compressUploadBeforeRead"
      />
    </div>

    <van-field
      clickable
      name="name"
      required
      label="评委姓名"
      placeholder="请输入评委真实姓名"
      v-model="formData.name"
      input-align="right"
      error-message-align="right"
      :error-message="validate.fieldMsg.name"
    />

    <van-field
      input-align="right"
      readonly
      clickable
      required
      :value="sex"
      name="sex"
      label="性别"
      placeholder="点击选择性别"
      error-message-align="right"
      :error-message="validate.fieldMsg.sexVal"
      @click="showPicker = true"
    />
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="[
          {
            text: '男',
            value: 0
          },
          {
            text: '女',
            value: 1
          }
        ]"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>

    <van-field
      input-align="right"
      readonly
      clickable
      required
      :value="major"
      name="major"
      label="专业"
      placeholder="点击选择专业"
      @click="majorPicker = true"
      error-message-align="right"
      :error-message="validate.fieldMsg.majorVal"
    >
      <template #input v-if="majorSelectList.length">
        <div class="tags">
          <van-tag
            closeable
            v-for="(tag, i) in majorSelectList"
            :key="i"
            type="primary"
            size="large"
            @close="deleteTag(i)"
            >{{ tag.text }}</van-tag
          >
        </div>
      </template>
      <template #input v-else>
        <span class="custom-span">请选择专业（多选）</span>
      </template>
    </van-field>
    <van-popup v-model="majorPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="majorList"
        @confirm="majorConfirm"
        @cancel="majorPicker = false"
      />
    </van-popup>
    <van-field
      input-align="right"
      readonly
      clickable
      required
      :value="activity"
      name="activity"
      label="活动"
      placeholder="点击选择活动"
      @click="activityPicker = true"
      error-message-align="right"
      :error-message="validate.fieldMsg.activityIdList"
    >
      <template #input v-if="activityIdList.length">
        <div class="tags">
          <van-tag
            closeable
            v-for="(tag, i) in activityIdList"
            :key="i"
            type="primary"
            size="large"
            @close="deleteActTag(i)"
            >{{ tag.text }}</van-tag
          >
        </div>
      </template>
      <template #input v-else>
        <span class="custom-span">请选择活动（多选）</span>
      </template>
    </van-field>
    <van-popup v-model="activityPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="activityList"
        @confirm="activityConfirm"
        @cancel="activityPicker = false"
      />
    </van-popup>

    <van-field
      clickable
      name="count"
      required
      v-model="formData.count"
      type="digit"
      label="点评次数"
      placeholder="可点评次数"
      input-align="right"
      :error-message="validate.fieldMsg.count"
      error-message-align="right"
      :style="{ marginBottom: '20px' }"
    />

    <van-field
      readonly
      input-align="right"
      clickable
      name="city"
      required
      :value="city"
      label="市区选择"
      placeholder="请选择地址"
      @click="showArea = true"
      error-message-align="right"
      :error-message="validate.fieldMsg.contactCity"
    />
    <van-popup v-model="showArea" position="bottom">
      <van-area
        :area-list="areaList"
        @confirm="areaConfirm"
        @cancel="showArea = false"
      />
    </van-popup>
    <van-field
      clickable
      name="address"
      required
      v-model="formData.address"
      label="通讯地址"
      placeholder="通讯地址"
      input-align="right"
      :error-message="validate.fieldMsg.address"
      error-message-align="right"
    />

    <van-field
      clickable
      required
      v-model="formData.weight"
      type="digit"
      label="专家权重"
      placeholder="权重越大展示越靠前"
      input-align="right"
      :error-message="validate.fieldMsg.weight"
      error-message-align="right"
    />
    <van-field
      clickable
      name="intro"
      required
      v-model="formData.intro"
      autosize
      rows="4"
      type="textarea"
      maxlength="300"
      label="专家简介"
      placeholder="请输入简介"
      show-word-limit
      input-align="right"
      :error-message="validate.fieldMsg.intro"
      error-message-align="right"
      :style="{ marginBottom: '20px' }"
    />

    <!-- <SignTitle title="账号信息" /> -->
    <van-field
      v-show="mode == 0"
      clickable
      required
      v-model="formData.phone"
      label="手机号码"
      placeholder="用于登录"
      input-align="right"
      :error-message="validate.reg_verify_err_msg.phone"
      error-message-align="right"
      maxlength="11"
      @change="validate.tel('phone')"
    />
    <van-field
      v-show="mode == 0"
      clickable
      name="pwd"
      required
      v-model="formData.pwd"
      label="账号密码"
      input-align="right"
      placeholder="初始登录密码，专家可修改"
      :error-message="validate.reg_verify_err_msg.pwd"
      error-message-align="right"
      @change="validate.pwd('pwd')"
    />

    <div class="create">
      <van-button
        size="large"
        @click="create"
        color="linear-gradient(to right, #5DD682, #5AFF8E)"
        >提交</van-button
      >
    </div>
    <Crop
      :popup.sync="compressShow"
      :img="compressImg"
      @close="cancelUpload"
      @getImageData="uploadHead"
    />
  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
// import SignTitle from "../../components/pub/SignTitle.vue";
import {
  getJudgesDetails,
  getCurrentActivityMajor,
  getActivityListByModel,
  addUserJudges,
  updUserJudges
} from "@/utils/api/channel";
import { uploadImg } from "@/utils/api/user";
import { checkUploadFile } from "@/utils/tool";
import { validate } from "@/utils/mixin/validate";
import Crop from "@/components/pub/CompressCrop.vue";
export default {
  mixins: [validate],
  components: {
    Crop
    // SignTitle
  },
  data() {
    return {
      // 省市区
      city: "",
      // 区域树
      areaList,
      // 显示区域选择
      showArea: false,
      // 头像
      head: [],
      // 需要提交的表单信息
      formData: {
        head: null,
        name: null,
        sexVal: null,
        count: null,
        address: null,
        intro: null,
        phone: null,
        pwd: null,
        majorVal: null,
        activityIdList: [],
        contactProvince: null,
        contactCity: null,
        contactArea: null,
        weight: null
      },
      // 专业列表
      majorList: [],
      // 活动列表
      activityList: [],
      // 性别
      sex: null,
      // 显示选择框
      showPicker: false,
      // 所选专业
      major: null,
      // 所选专业
      majorSelectList: [],
      // 所选活动
      activity: null,
      // 所选活动
      activityIdList: [],
      // 显示选择
      majorPicker: false,
      // 显示活动选择
      activityPicker: false,
      // 标签
      tags: [],
      mode: 0, // 0新增，1修改
      compressShow: false,
      compressImg: ""
    };
  },
  methods: {
    // 删除照片
    headBeforeDel() {
      this.formData.head = null;
      return true;
    },
    cancelUpload() {
      this.compressShow = false;
      this.head = [];
    },
    // 上传头像
    async uploadHead(file) {
      const pass = checkUploadFile({ file, size: 1 }, (err) => {
        this.$root.$toast.fail(err);
        this.head = [
          {
            url: "",
            message: "图片大于1m，请重新选择图片。",
            status: "failed",
            name: file.name
          }
        ];
      });
      if (!pass) {
        return;
      }
      this.head = [
        {
          url: "",
          status: "uploading",
          message: "上传中...",
          name: file.name
        }
      ];
      this.$forceUpdate();
      let upimgobj = new FormData();
      this.$root.$toast.loading({
        message: "上传图片中……",
        duration: 0
      });
      upimgobj.append("file", file);
      const { data: url, success } = await uploadImg(upimgobj);
      if (success) {
        this.head = [
          {
            url,
            status: "done",
            name: file.name
          }
        ];
        this.formData.head = url;
      } else {
        this.head = [
          {
            url: "",
            message: "上传失败，请重新上传",
            status: "failed",
            name: file.name
          }
        ];
      }
      this.$forceUpdate();
      this.$root.$toast.clear();
    },
    // 上传前预处理
    uploadBeforeRead(file) {
      const pass = checkUploadFile({ file, size: 1 }, (err) => {
        this.$root.$toast.fail(err);
      });
      if (!pass) {
        return false;
      }
      this.head = [
        {
          url: "",
          status: "uploading",
          message: "上传中..."
        }
      ];
      let upimgobj = new FormData();
      upimgobj.append("file", file);
      uploadImg(upimgobj).then(({ success, data: url }) => {
        if (success) {
          this.head = [
            {
              url,
              status: "done"
            }
          ];
          this.formData.head = url;
          return success;
        } else {
          this.head = [
            {
              url: "",
              message: "上传失败，请重新上传",
              status: "failed"
            }
          ];
          return false;
        }
      });
    },
    // 压缩上传预处理
    compressUploadBeforeRead(file) {
      this.compressImg = URL.createObjectURL(file);
      this.head = [
        {
          url: "",
          status: "uploading",
          message: "图片编辑...",
          name: file.name
        }
      ];
      this.$forceUpdate();
      this.compressShow = true;
    },
    // 性别确认回执
    onConfirm(item) {
      this.sex = item.text;
      this.formData.sexVal = item.value;
      this.showPicker = false;
    },
    // 区域确定
    areaConfirm(values) {
      this.city = `${values[0].name} ${values[1].name} ${values[2].name}`;
      this.formData.contactProvince = values[0].name;
      this.formData.contactCity = values[1].name;
      this.formData.contactArea = values[2].name;
      this.showArea = false;
    },
    // 专业确认回执
    majorConfirm(item) {
      if (
        this.majorSelectList
          .map((e) => {
            return e.value;
          })
          .includes(item.value)
      ) {
        this.majorPicker = false;
        return;
      }
      this.major = item.text;
      this.majorSelectList.push(item);
      this.formData.majorVal = this.majorSelectList
        .map((e) => {
          return e.value;
        })
        .join(",");
      this.majorPicker = false;
    },
    // 删除专业标签
    deleteTag(i) {
      this.majorSelectList.splice(i, 1);
    },
    // 活动确认回执
    activityConfirm(item) {
      if (
        this.activityIdList
          .map((e) => {
            return e.value;
          })
          .includes(item.value)
      ) {
        this.activityPicker = false;
        return;
      }
      this.activity = item.text;
      this.activityIdList.push(item);

      for (let i of this.activityIdList) {
        this.formData.activityIdList.push(i.value);
      }
      this.activityPicker = false;
    },
    // 删除活动标签
    deleteActTag(i) {
      this.activityIdList.splice(i, 1);
    },

    // 提交表单数据
    async create() {
      if (this.mode == 0) {
        let res = this.validate.tel("phone");
        if (!res) {
          this.$root.$toast.fail("请输入正确的手机号码！");
          return;
        }
        if (!this.formData.pwd) {
          this.validate.reg_verify_err_msg.pwd = "请输入密码！";
          this.$root.$toast.fail("请输入密码！");
          return;
        }
      }
      // 验证数据
      const dataValidate = () => {
        return new Promise((res) => {
          const lastKey = "majorVal";
          const lastKey2 = "activityIdList";
          for (let key in this.formData) {
            if (key === "head") {
              let pass = this.validate.isNull(key);
              if (!pass) {
                this.$root.$toast.fail("请上传头像");
                res(false);
              }
            } else if (this.mode === 0) {
              let pass = this.validate.isNull(key);
              if (!pass) res(false);
              if (key === lastKey) {
                res(true);
              }
              if (key === lastKey2) {
                res(true);
              }
              this.$forceUpdate();
            } else if (this.mode === 1) {
              if (key !== "phone" && key !== "pwd") {
                let pass = this.validate.isNull(key);
                if (!pass) res(false);
                if (key === lastKey) {
                  res(true);
                }
                if (key === lastKey2) {
                  res(true);
                }
                this.$forceUpdate();
              }
            }
          }
        });
      };
      const result = await dataValidate();
      if (!result) {
        this.validate.errMsgPopup();
        this.validate.errMsgEmpty();
        return;
      } else {
        const {
          head,
          name,
          sexVal,
          majorVal,
          count,
          address,
          intro,
          phone,
          pwd,
          contactProvince,
          contactCity,
          contactArea,
          weight,
          activityIdList
        } = this.formData;
        let p = {
          activityIdList,
          realName: name,
          sex: sexVal,
          majorIds: majorVal,
          commentNum: count,
          contactAddress: address,
          synopsis: intro,
          tel: phone,
          password: pwd,
          userImg: head,
          contactProvince,
          contactCity,
          contactArea,
          weight: parseInt(weight)
        };
        if (this.mode) {
          p = Object(p, { id: this.id });
          p.id = this.id;
          delete p.tel;
          delete p.password;
          updUserJudges(p).then((res) => {
            if (res.success) {
              this.$root.$toast.success({
                message: "编辑成功",
                duration: 2000,
                onClose: () => {
                  // this.$router.push("/home/expert");
                  this.$router.go(-1);
                }
              });
            }
          });
        } else {
          addUserJudges(p).then((res) => {
            if (res.success) {
              this.$root.$toast.success({
                message: "添加成功",
                duration: 2000,
                onClose: () => {
                  // this.$router.push("/home/expert");
                  this.$router.go(-1);
                }
              });
            }
          });
        }
      }
    },
    // 获取编辑详情数据
    getEditInfo() {
      getJudgesDetails(this.id).then((res) => {
        if (res.success) {
          const d = res.data;
          this.formData = {
            activityIdList: d.activityIdList,
            head: d.userImg,
            name: d.realName,
            sexVal: d.sex,
            majorVal: d.majorIds,
            count: d.commentNum,
            address: d.contactAddress,
            intro: d.synopsis,
            phone: d.tel,
            pwd: d.password,
            contactProvince: d.contactProvince,
            contactCity: d.contactCity,
            contactArea: d.contactArea,
            weight: d.weight
          };
          // 设置头像

          this.head = [
            {
              url: d.userImg,
              status: "done"
            }
          ];
          // 设置性别
          this.sex = d.sex ? "女" : "男";
          // 设置专业
          const majorKeys = d.majorIds.split(",").map((e) => {
            return parseInt(e);
          });
          this.majorList.map((e) => {
            if (majorKeys.includes(e.value)) {
              this.majorSelectList.push(e);
            }
          });
          if (d.activityIdList) {
            this.activityList.map((e) => {
              if (d.activityIdList.includes(e.value)) {
                this.activityIdList.push(e);
              }
            });
          }

          // 设置省市区
          this.city = `${d.contactProvince} ${d.contactCity} ${d.contactArea}`;
        }
      });
    },
    // 获取活动
    getActivityList() {
      getActivityListByModel(0).then((res) => {
        if (res.success) {
          this.activityList = res.data.map((e) => {
            return {
              text: e.name,
              value: e.activityId
            };
          });
          if (this.mode) {
            this.id = this.$route.query.id;
            this.getEditInfo();
            document.title = "编辑评委";
          }
        }else{
			if (this.mode) {
			  this.id = this.$route.query.id;
			  this.getEditInfo();
			  document.title = "编辑评委";
			}
		}
      });
    },
    // 获取专业
    getMajorList() {
      getCurrentActivityMajor().then((res) => {
        if (res.success) {
          this.majorList = res.data.map((e) => {
            return {
              text: e.majorName,
              value: e.majorId
            };
          });
          this.getActivityList();
        }
      });
    }
  },
  mounted() {
    this.validate.setFormDataKey("formData");
    this.getMajorList();
    // this.getActivityList();
    const mode = parseInt(this.$route.query.mode);
    this.mode = mode;
    // if (mode) {
    //   this.id = this.$route.query.id;
    //   this.getEditInfo();
    //   document.title = "编辑评委";
    // }
  }
};
</script>

<style lang="scss" scoped>
.add-expert {
  overflow: hidden;
  background: #f2f2f2;
  .tags {
    .van-tag {
      height: 32px;
      margin-left: 3px;
      margin-bottom: 3px;
      border-radius: 4px;
      border: #f2f2f2;
      min-width: 60px;
      background-color: #ecf5ff;
      color: #666;
      font-size: 12px;
      text-align: center;
      display: inline-block;
      line-height: 26px;
    }
  }
  .create {
    margin: 0 auto;
    width: 254px;
    margin-top: 40px;
    margin-bottom: 60px;
    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/css/customer.scss";
.add-expert {
  text-align: left;
  .van-cell {
    &::after {
      border: none;
    }
  }
  .van-uploader {
    @include from-upload-style;
  }
  .custom-title {
    color: #646566;
  }
  .custom-tit {
    font-size: 12px;
    color: #ccc;
  }
  .expert-head {
    text-align: left;
    padding-top: 10px;
    padding-left: 10px;
    background: #fff;
  }
  .custom-span {
    color: #ccc;
  }
  .affixs-label {
    width: unset;
    & + .van-field__value {
      display: none;
    }
  }
}
</style>
